import React from 'react';
import { Tooltip } from '@patternfly/react-core';
import { MatrixCell as MatrixCellType } from '../../types/reports';
import { formatTimeForReport } from '../../utils/reportHelpers';

interface MatrixCellProps {
  cell: MatrixCellType;
  isTotal?: boolean;
}

export const MatrixCell: React.FC<MatrixCellProps> = ({ cell, isTotal = false }) => {
  const displayValue = formatTimeForReport(cell.totalSeconds);
  const hasValue = cell.totalSeconds > 0;

  const classNames = [
    'matrix-cell',
    cell.isWeekend && !isTotal ? 'matrix-cell--weekend' : '',
    isTotal ? 'matrix-cell--total' : '',
    hasValue ? 'matrix-cell--has-value' : '',
  ]
    .filter(Boolean)
    .join(' ');

  const tooltipContent = hasValue ? (
    <div>
      <div>{cell.date}</div>
      <div>
        {Math.floor(cell.totalSeconds / 3600)}h {Math.floor((cell.totalSeconds % 3600) / 60)}m
      </div>
      <div>{cell.logCount} log(s)</div>
    </div>
  ) : null;

  const cellContent = <div className={classNames}>{displayValue}</div>;

  if (hasValue && tooltipContent) {
    return <Tooltip content={tooltipContent}>{cellContent}</Tooltip>;
  }

  return cellContent;
};
